import { render, staticRenderFns } from "./ModalDisplayRole.vue?vue&type=template&id=4eac5049&scoped=true"
import script from "./ModalDisplayRole.vue?vue&type=script&lang=js"
export * from "./ModalDisplayRole.vue?vue&type=script&lang=js"
import style0 from "./ModalDisplayRole.vue?vue&type=style&index=0&id=4eac5049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac5049",
  null
  
)

export default component.exports